import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { fetchOrdersByStatus } from '../api/order';

const OrderTracking = () => {
  const [trackingOrders, setTrackingOrders] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('Pending');
  const user  = JSON.parse(localStorage.getItem("user"));

  const fetchOrders = async (status) => {
   if (!user?._id) return;

  try {
    const data = await fetchOrdersByStatus(user._id, status);
    setTrackingOrders(data);
  } catch (err) {
    setTrackingOrders([]);
  }
  };

  useEffect(() => {
    fetchOrders(selectedStatus);
  }, [selectedStatus, user?._id]);

  const formatDate = (dateString) => {
    const [datePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('-');
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const monthName = monthNames[parseInt(month, 10) - 1];
    return `${day}-${monthName}-${year}`;
  };

  return (
    <>
      <div className="min-h-screen bg-gray-950 text-white pt-24 pb-10 px-4">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-4xl font-extrabold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">
            Track Orders
          </h1>

          <div className="flex flex-wrap gap-3 justify-center mb-8">
            {['Pending', 'Processing', 'Shipped', 'Delivered'].map((status) => (
              <button
                key={status}
                onClick={() => setSelectedStatus(status)}
                className={`px-5 py-2 rounded-full font-semibold transition-transform hover:scale-105 shadow-lg ${
                  selectedStatus === status
                    ? 'bg-gradient-to-r from-cyan-500 to-purple-600 text-white'
                    : 'bg-gray-800 text-white border border-cyan-600'
                }`}
              >
                {status}
              </button>
            ))}
          </div>

          {trackingOrders.length === 0 ? (
            <div className="text-center py-10 text-white/70">
              No orders found with {selectedStatus} status.
            </div>
          ) : (
            <div className="overflow-x-auto bg-gray-900 rounded-2xl p-6 border border-purple-700 shadow-lg">
              <table className="min-w-full text-sm text-white">
                <thead>
                  <tr className="text-cyan-400 uppercase text-xs border-b border-cyan-700">
                    <th className="p-3 text-left">Order ID</th>
                    <th className="p-3 text-left">Date</th>
                    <th className="p-3 text-left">Items</th>
                    <th className="p-3 text-left">Total</th>
                    <th className="p-3 text-left">Location</th>
                    <th className="p-3 text-left">Status</th>
                    <th className="p-3 text-left">Payment</th>
                  </tr>
                </thead>
                <tbody>
                  {trackingOrders.map((order) => (
                    <tr key={order._id} className="border-b border-gray-800 hover:bg-gray-800">
                      <td className="p-3 font-semibold text-purple-400">#{order._id.slice(-6)}</td>
                      <td className="p-3 text-white/80">{formatDate(order.date_time)}</td>
                      <td className="p-3">
                        <ul className="space-y-1 text-white/80">
                          {order.items.map((item, index) => (
                            <li key={index}>{item.product_name} ({item.quantity}) - ₹{item.price}</li>
                          ))}
                        </ul>
                      </td>
                      <td className="p-3 font-bold text-cyan-400">₹{order.amount}</td>
                      <td className="p-3 text-white/80">{order.location}</td>
                      <td className="p-3">
                        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                          order.order_status === 'Pending' ? 'bg-yellow-500/20 text-yellow-400' :
                          order.order_status === 'Processing' ? 'bg-blue-500/20 text-blue-400' :
                          order.order_status === 'Shipped' ? 'bg-indigo-500/20 text-indigo-400' :
                          order.order_status === 'Delivered' ? 'bg-green-500/20 text-green-400' :
                          'bg-gray-500/20 text-gray-400'
                        }`}>
                          {order.order_status}
                        </span>
                      </td>
                      <td className="p-3">
                        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                          order.is_paid === 'YES' ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'
                        }`}>
                          {order.is_paid === 'YES' ? 'Paid' : 'Unpaid'}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

    </>
  );
};

export default OrderTracking;
